import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value", "name"]
const _hoisted_2 = ["value"]

import { useField } from 'vee-validate'
import { ISelectOption } from '@/types/interfaces/select'

interface IPropsTheInput {
    placeholder?: string
    modelValue?: number
    inputName?: string
    options: ISelectOption[] | null
}
interface IEventTheInput {
    (e: 'update:modelValue', value: number): void
}

function setup(__props: any, { emit }: { emit: ({
    (e: 'update:modelValue', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { placeholder: string, modelValue: number, inputName: string, options: ISelectOption[] | null }



const { value, errorMessage, handleChange } = useField(props.inputName, undefined, {
    initialValue: props.modelValue,
})
const defaultOptions = [{ name: props.placeholder, id: -1 }]
const handleEvent = (event: Event) => {
    handleChange(event)
    if (event.target) {
        emit('update:modelValue', value.value)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("select", _mergeProps(_ctx.$attrs, {
      value: __props.modelValue,
      name: __props.inputName,
      class: [{ 'pb-3 mb-8': !_unref(errorMessage) }, "bg-white serif text-secondary mr-4 font-serif font-medium p-4 leading-none w-full border border-gray-stroke"],
      onChange: handleEvent
    }), [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultOptions.concat(__props.options ? __props.options : []), (option, optionId) => {
        return (_openBlock(), _createElementBlock("option", {
          key: optionId,
          value: option.id
        }, _toDisplayString(option.name), 9, _hoisted_2))
      }), 128))
    ], 16, _hoisted_1),
    _withDirectives(_createElementVNode("p", { class: "text-red" }, _toDisplayString(_unref(errorMessage)), 513), [
      [_vShow, _unref(errorMessage)]
    ])
  ]))
}
}


const __default__ = {
    inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    placeholder: { type: String, required: false, default: 'Wybierz opcję' },
    modelValue: { type: Number, required: false, default: -1 },
    inputName: { type: String, required: false, default: '' },
    options: { type: [Array, null], required: true }
  },
  emits: ["update:modelValue"],
  setup})